module.exports = __webpack_public_path__ + "assets/21692f11d3c3957e67321f0fddd94704.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/ro/video.mp4
// module id = 357
// module chunks = 1